import { styled } from "@mui/material";
import { themeFonts } from "../Constant/themeFont";
import TypographyBodyBase from "./TypographyBodyBase";

const TypographyBodyRegular = styled(TypographyBodyBase)(({ theme, color }) => ({
  fontFamily: themeFonts.regular,
}));

export default TypographyBodyRegular;